import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PrescriberForm } from "../PrescriberForm";
import { CreatePrescriberModalProps } from "./types";
import { useCreatePrescriberModal } from "./controller";

export const CreatePrescriberModal = React.memo(({ modalRef, onComplete }: CreatePrescriberModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreatePrescriberModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("prescriber_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <PrescriberForm />
    </Modal>
  );
});
